var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLashenti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13H0.5V3L2 1.5L8 0.5L14 1.5L15.5 3V13Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13C15.5 13.2199 15.383 13.4892 15.0396 13.7936C14.6969 14.0975 14.1723 14.394 13.4813 14.6532C12.1029 15.1701 10.1651 15.5 8 15.5C5.83494 15.5 3.89713 15.1701 2.51871 14.6532C1.82765 14.394 1.30314 14.0975 0.960383 13.7936C0.61704 13.4892 0.5 13.2199 0.5 13C0.5 12.7801 0.61704 12.5108 0.960383 12.2064C1.30314 11.9025 1.82765 11.606 2.51871 11.3468C3.89713 10.8299 5.83494 10.5 8 10.5C10.1651 10.5 12.1029 10.8299 13.4813 11.3468C14.1723 11.606 14.6969 11.9025 15.0396 12.2064C15.383 12.5108 15.5 12.7801 15.5 13Z",
    fill: "#00C2FF",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3C15.5 3.21987 15.383 3.4892 15.0396 3.79361C14.6969 4.0975 14.1723 4.39401 13.4813 4.65316C12.1029 5.17006 10.1651 5.5 8 5.5C5.83494 5.5 3.89713 5.17006 2.51871 4.65316C1.82765 4.39401 1.30314 4.0975 0.960383 3.79361C0.61704 3.4892 0.5 3.21987 0.5 3C0.5 2.78013 0.61704 2.5108 0.960383 2.20639C1.30314 1.9025 1.82765 1.60599 2.51871 1.34684C3.89713 0.829936 5.83494 0.5 8 0.5C10.1651 0.5 12.1029 0.829936 13.4813 1.34684C14.1723 1.60599 14.6969 1.9025 15.0396 2.20639C15.383 2.5108 15.5 2.78013 15.5 3Z",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3V13",
    stroke: "black",
    strokeDasharray: "1 1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3V13",
    stroke: "black",
    strokeDasharray: "1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLashenti);
export default __webpack_public_path__ + "static/media/lashenti.fc946971e9d869470d24ef6ab5fd0b30.svg";
export { ForwardRef as ReactComponent };